/* eslint-disable jsx-a11y/anchor-has-content */
import { useI18nContext, Trans } from "@hopper-b2b/i18n";
import { HSBC_APP_LINK } from "@hsbc/portal";
import clsx from "clsx";
import "./styles.scss";

export const ComingSoon = () => {
  const { t } = useI18nContext();
  return (
    <div className={clsx("hsbc-coming-soon-content")}>
      <h2>{t("comingSoon.title")}</h2>
      <span>
        <Trans
          i18nKey={"comingSoon.subtitle"}
          components={[<a href={HSBC_APP_LINK} target="_blank" />]}
        ></Trans>
      </span>
    </div>
  );
};

export default ComingSoon;
